import { render, staticRenderFns } from "./LibraryCategoriesModal.vue?vue&type=template&id=ec4b6dc8&scoped=true"
import script from "./LibraryCategoriesModal.vue?vue&type=script&lang=ts"
export * from "./LibraryCategoriesModal.vue?vue&type=script&lang=ts"
import style0 from "./LibraryCategoriesModal.vue?vue&type=style&index=0&id=ec4b6dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4b6dc8",
  null
  
)

export default component.exports